import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Router } from '@angular/router';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { FeatureFlagService } from '@next/core-lib/featureflag';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { TableV2Module } from '@next/core-lib/table-v2';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';

import { Environment } from 'src/environments/environment.model';

import { AbstractRepeatOrderPageComponent, RepeatOrderType } from './abstract-repeat-order-page-component.directive';

import { FormatAddProductToCartButtonTextPipe } from '../../../product/pipes/format-add-product-to-cart-button-text.pipe';
import { FormatFlexibilityDatePipe } from '../../../product/pipes/format-flexibility-date.pipe';
import { FavoritesStarComponent } from '../../../standalone/favorites-star/favorites-star.component';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-general-cargo-repeat-order-page',
  templateUrl: 'repeat-order-page.component.html',
  styleUrls: ['./repeat-order-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    MatButton,
    MatIcon,
    TableV2Module,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFormField,
    MatLabel,
    MatInput,
    AgrFormModule,
    FormsModule,
    ReactiveFormsModule,
    MatSuffix,
    NgFor,
    NgClass,
    FavoritesStarComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    AsyncPipe,
    AgrI18nSharedModule,
    FormatFlexibilityDatePipe,
    FormatAddProductToCartButtonTextPipe,
  ],
})
export class GeneralCargoRepeatOrderPageComponent extends AbstractRepeatOrderPageComponent {
  constructor(store: Store, @Inject(EnvironmentInjector) environment: Environment, router: Router, featureFlagService: FeatureFlagService) {
    super(store, environment, RepeatOrderType.generalCargo, router, featureFlagService);
  }
}
